import { createContext, useContext, useEffect, useState } from 'react'

import { EVENT_KEYS } from '@/services/events'

const initialState = { width: undefined, height: undefined }

interface Size {
  width: number | undefined
  height: number | undefined
}

interface WindowSizeContextType {
  windowSize: Size
}

export const WindowSizeContext = createContext<WindowSizeContextType>(
  {} as WindowSizeContextType
)

interface WindowSizeProviderProps {
  children: React.ReactNode
}

export function WindowSizeProvider({ children }: WindowSizeProviderProps) {
  const [windowSize, setWindowSize] = useState<Size>(initialState)

  useEffect(() => {
    handleResize()

    window.addEventListener(EVENT_KEYS.resize, handleResize)
    return () => {
      window.removeEventListener(EVENT_KEYS.resize, handleResize)
    }
  }, [])

  const handleResize = () => {
    const size = {
      width: window.innerWidth,
      height: window.innerHeight
    }
    setWindowSize(size)
  }

  return (
    <WindowSizeContext.Provider value={{ windowSize }}>
      {children}
    </WindowSizeContext.Provider>
  )
}

export function useWindowSize() {
  return useContext(WindowSizeContext)
}
